import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const PercentageSubCell = (props: GridCellProps) => {
  const { displayValue } = useGridCellDisplayValue(props);

  return (
    <GridCellBase {...props} title={`${displayValue}%`}>
      <p className="text-left">{displayValue}%</p>
    </GridCellBase>
  );
};

export default PercentageSubCell;
